import { Component } from 'react';

import { ThumbDown as ThumbDownIcon, ThumbUp as ThumbUpIcon } from '@mui/icons-material';
import { Box, Button, Checkbox, CircularProgress, FormControlLabel, IconButton, TextField } from '@mui/material';
import { flowRight as compose, isUndefined } from 'lodash';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'providers';

import * as E from './styles';

class ShipmentFeedback extends Component {
  addFeedBack = (e) => {
    const { toggleFeedback } = this.props;
    const { feedbackForm, selectedStop } = this.props.store.shipmentStore;

    if (!selectedStop) return;

    this.props.store.shipmentStore.addFeedback(selectedStop.id, () => toggleFeedback());
  };

  render() {
    const { feedbackForm, addingFeedback } = this.props.store.shipmentStore;
    const tagValues = [
      'Late due to Driver',
      'Inappropriate behavior',
      'Confirmed delivery',
      'Damaged - Jitsu',
      'Instructions not followed',
      'Delivered to wrong address',
      'Unconfirmed delivery',
    ];
    const thumb = feedbackForm.getField('thumb', undefined);

    return (
      <E.Container>
        <E.Inner>
          <E.Row>
            <E.Label>{`Rate:`}</E.Label>
            <E.Content>
              <Box component="span" px={1}>
                <IconButton size="small" onClick={() => feedbackForm.handlerRating('thumb')(true)}>
                  <ThumbUpIcon fontSize="small" style={isUndefined(thumb) ? {} : { color: !!thumb ? '#4abc4e' : '' }} />
                </IconButton>
              </Box>
              <Box component="span" px={1}>
                <IconButton size="small" onClick={() => feedbackForm.handlerRating('thumb')(false)}>
                  <ThumbDownIcon fontSize="small" style={isUndefined(thumb) ? {} : { color: !thumb ? '#d0021b' : '' }} />
                </IconButton>
              </Box>
            </E.Content>
          </E.Row>
          <E.Row>
            <E.Label>{`Tags:`}</E.Label>
            <E.Content>
              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                {tagValues.map((v) => (
                  <E.Control key={`tag-${v}`}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={feedbackForm.arrayContains('tags', v)}
                          onChange={feedbackForm.handlerCheckboxes}
                          name="tags"
                          value={v}
                          size="small"
                          style={{ paddingTop: '2px' }}
                        />
                      }
                      label={v}
                      style={{ alignItems: 'flex-start' }}
                    />
                  </E.Control>
                ))}
              </Box>
            </E.Content>
          </E.Row>
          <E.Row>
            <E.Label>{`Comment:`}</E.Label>
            <E.Content>
              <TextField
                multiline
                rows={5}
                variant="outlined"
                fullWidth
                value={feedbackForm.getField('comment', '')}
                onChange={feedbackForm.handlerTextarea}
                name="comment"
                placeholder={`Add comment...`}
              />
            </E.Content>
          </E.Row>
          <E.Row>
            <E.Label />
            <E.Content>
              <Button onClick={this.addFeedBack} variant="contained" color="primary" size="small" disableElevation sx={{ mr: 2 }}>
                {addingFeedback && <CircularProgress size={16} sx={{ mr: 0.5 }} />} Add Feedback
              </Button>
              <Button onClick={() => this.props.onClose && this.props.onClose()} variant="outlined" color="primary" size="small" disableElevation>
                Cancel
              </Button>
            </E.Content>
          </E.Row>
        </E.Inner>
      </E.Container>
    );
  }
}
export default compose(withRouter, inject('store'), observer)(ShipmentFeedback);
